<template>
  <article class="active-ingredient-info">
    <h4 class="active-ingredient-info__title">{{ $t(title) }}</h4>
    <span
      v-if="concentrationText"
      class="active-ingredient-info__concentration u-typography-helvetica u-text u-text--link u-text--xs"
      >{{ concentrationText }}</span
    >

    <p
      v-for="paragraph of descriptionParagraphs"
      :key="paragraph"
      class="active-ingredient-info__paragraph u-typography-helvetica u-text u-text--xs"
    >
      {{ $t(paragraph) }}
    </p>
  </article>
</template>

<script>
export default {
  name: 'ConstantIngredientInfo',
  props: {
    title: {
      type: String,
      required: true
    },
    descriptionParagraphs: {
      type: Array,
      required: true
    },
    concentration: {
      type: String,
      default: ''
    }
  },
  computed: {
    concentrationText() {
      if (!this.concentration) {
        return '';
      }

      return this.$t('constantActiveIngredient.concentration', [this.concentration]);
    }
  }
};
</script>

<style lang="scss" scoped>
.active-ingredient-info {
  &__title {
    font-family: var(--u-font-family-Helvetica);
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: 0.4px;
    margin-bottom: 16px;
  }

  &__concentration {
    margin-bottom: 16px;
    display: inline-block;
  }

  &__paragraph:not(:last-child) {
    margin-bottom: 16px;
  }
}
</style>
